<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <h1 class="title is-5">{{ getTitle }}</h1>
          </div>
        </div>
      </div>
    </section>
    <section class="container section page-header section is-main-section">
      <template>
        <section>
          <b-tabs v-model="activeTab">
            <b-tab-item class="label" label="User Listing" :disabled="isListing">
              <form @submit.prevent="SendToUser">
                <card-component>
                  <div class="columns form-row">
                    <div class="column is-12">
                      <div class="field">
                        <div class="label has-text-right right-align">
                          Total Count: <b> {{ total }}</b><br />
                          Selected Count: <b> {{ email.checkedRows.length }} </b>
                        </div>
                      </div>
                    </div>
                  </div>

                  <section class="section is-main-section">
                    <card-component class="has-table has-mobile-sort-spaced">
                      <b-input placeholder="Search..." type="search" v-model="searchTerm"
                        @input="customSearch(searchTerm)"></b-input>
                      <b-table checkable :checked-rows.sync="email.checkedRows"
                        :paginated="paginated" :per-page="10" :columns="columns" :striped="true"
                        :hoverable="true" :data="searchFilterArray" v-model="email.getAllData">
                        <section class="section" slot="empty">
                          <div class="content has-text-grey has-text-centered">
                            <template>
                              <p>
                                <b-icon icon="emoticon-sad" size="is-large" />
                              </p>
                              <p>Nothing's here&hellip;</p>
                            </template>
                          </div>
                        </section>
                      </b-table>
                    </card-component>
                  </section>
                </card-component>
                <footer class="column has-text-right">
                  <button class="button is-success" type="submit"
                    :disabled="isDisabled">Next</button>
                </footer>
              </form>
            </b-tab-item>

            <b-tab-item class="label" label="Message Content" :disabled="isMessage">
              <form @submit.prevent="SendMsgToUser">
                <card-component>
                  <div v-if="sendType==='Email'">
                    <div class="columns form-row">
                      <div class="column is-10">
                        <div class="field">
                          <label class="label"> Subject: </label>
                          <div class="control form-row is-fullwidth">
                            <input type="text" v-model="email.emailSubject"
                              :disabled="emailSubTxtBox" class="input" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="columns form-row">
                      <div class="column is-10">
                        <div class="field">
                          <label class="label"> Email Content </label>
                          <ckeditor v-model="email.emailEditorData" :read-only="emailContentTxtBox" ref="ckeditorRef">
                          </ckeditor>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="columns form-row">
                      <div class="column is-6">
                        <div class="field left-align">
                          <label class="label">
                            {{ MsgText }}
                            <span class="has-text-danger">*</span>
                          </label>
                          <div class="control">
                            <textarea @keypress="onKeyPressTxtMsg($event)"
                              @keydown="onKeyPressTxtMsg($event)" @keyup="onKeyPressTxtMsg($event)"
                              required v-model.trim="email.messageText"
                              :aria-readonly="readOnlyTxtBox" placeholder="Message.." type="text"
                              class="textarea resizetxtarea" maxlength="90" minlength="10">
                    </textarea>
                            <p v-show="showCharacter" class="text-right text-small"
                              v-bind:class="{ 'text-danger': generateErr }">Characters
                              :{{ totalRemainCount }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="column is-6" v-show="SendSMSTextDiv">
                        <div class="field left-align">
                          <label class="label"> SMS Send Text </label>
                          <div class="control">{{ SendSMSText }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </card-component>
                <footer class="column has-text-right">
                  <button class="button is-success" type="submit"
                    :disabled="isDisabled">Send</button>
                </footer>
              </form>
            </b-tab-item>
          </b-tabs>

        </section>
      </template>
    </section>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import CardComponent from '@/components/template/CardComponent'
// import Vue from 'vue'
// import CKEditor from 'ckeditor4-vue'
import _ from 'lodash'
// Vue.use(CKEditor)

export default {
  name: 'sendEmail',
  components: {
    CardComponent
  },
  props: ['id'],
  data () {
    return {
      getTitle: 'Send Email/SMS',
      isListing: true,
      isMessage: true,
      activeTab: 0,
      limitmaxCount: 90,
      totalRemainCount: 90,
      generateErr: false,
      showCharacter: false,
      SendSMSTextDiv: false,
      SendSMSText: '',
      readOnlyTxtBox: false,
      sendType: '',
      null: null,
      data: [],
      searchFilterArray: [],
      total: 0,
      paginated: false,
      perPage: 10,
      MsgText: 'Message:(Should starts with Dear Sir/Madam)',
      emailSubTxtBox: false,
      emailContentTxtBox: false,
      searchTerm: '',
      isDisabled: false,
      columns: [],
      TableData: [],
      email: {
        franchiseeID: '',
        emailTemplateType: '',
        sendTo: 'Staff',
        addCC: '',
        staffDepartmentType: 'All',
        templateTypeValue: '',
        academicYearsValue: '',
        pointOfContact: ['pointOfContact'],
        classes: '',
        staffDept: '',
        section: '',
        gender: 'all',
        studentType: 'all',
        selectedStudent: '',
        messageText: '',
        emailEditorData: '',
        emailSubject: '',
        getAllData: '',
        checkedRows: []
      }
    }
  },
  async created () {
    try {
      this.getTitle = 'Send Email/SMS'
      if (this.$route.query.sendType === 'Email' || this.$route.query.sendType === 'SMS') {
        if (this.$route.query.type === 'student' || this.$route.query.type === 'staff' || this.$route.query.type === 'enquiry') {
          if (this.$route.query.type && this.$route.query.pageType && this.$route.query.franchiseeID) {
            this.GetUserData()
          } else {
            this.isDisabled = true
            this.errMsg('Pass valid Parameter on Url')
          }
        } else {
          this.isDisabled = true
          this.errMsg('Pass valid Type Parameter on Url')
        }
      } else {
        this.errMsg('Pass valid sendType Parameter on Url')
      }
    } catch (e) {
      const errorMessage = (e && e.response && e.response.data.message) || e.message
      this.errMsg(errorMessage)
    }
  },
  watch: {
    activeTab (tabNo) {
      if (tabNo === 0) {
        this.isMessage = true
      } else {
        this.isListing = false
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    // Ckeditor maximize fix
    const that = this.$refs.ckeditorRef
    const maximizedState = that.instance.getCommand('maximize').state
    if (maximizedState === 1) { that.instance.execCommand('maximize') }
    next()
  },
  methods: {
    SendMsgToUser: async function () {
      try {
        if (this.sendType === 'Email' && this.$route.query.pageType === 'Admission_Fee_Link') {
          this.loadingComponent = this.$buefy.loading.open()
          this.isDisabled = true
          let filterData = {}
          this.userIDs = []
          this.email.checkedRows.forEach((Obj) => {
            console.log(Obj)
            this.userIDs.push(Obj.userId)
          })
          filterData.userIDs = this.userIDs
          filterData.franchiseeID = this.$route.query.franchiseeID
          if (this.$route.query.type === 'student') {
            filterData.userType = 'Enroll'
          } else {
            filterData.userType = this.$route.query.type
          }
          filterData.templateID = this.email.templateTypeValue
          filterData.pageName = this.$route.query.pageType
          const notificationResult = await http.post(`${constants.API_URL}/api/communication/notificationAdmissionEmail`, filterData)
          console.log(notificationResult)
          this.okMsg(`${this.sms.checkedRows.length} Email Send Successfully`)
          this.loadingComponent.close()
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While Sending Email: ${errorMessage}`)
      }
    },
    customSearch: function (value) {
      if (_.isEmpty(value)) {
        this.searchFilterArray = this.TableData
      } else {
        if (this.email.sendTo.toString() === 'Parent') {
          this.searchFilterArray = _.filter(
            this.TableData,
            (item) =>
              (this.email.pointOfContact.includes('pointOfContact') && item && item.StudentName.toLowerCase().search(value.toLowerCase()) >= 0) ||
              (item && item.Class.toLowerCase().search(value.toLowerCase()) >= 0) ||
              (item && item.Section.toLowerCase().search(value.toLowerCase()) >= 0) ||
              (this.email.pointOfContact.includes('pointOfContact') && item && item.pointOfContact.toLowerCase().search(value.toLowerCase()) >= 0)
          )
        } else if (this.email.sendTo.toString() === 'Staff') {
          this.searchFilterArray = _.filter(
            this.TableData,
            (item) => (item && item.StaffName.toLowerCase().search(value.toLowerCase()) >= 0) || (item && item.StaffEmailId.toLowerCase().search(value.toLowerCase()) >= 0)
          )
        }
      }
      this.total = this.searchFilterArray.length
    },
    userListing: function () {
      if (this.email.userType.toString() === 'student') {
        this.TableData = []
        this.data.forEach((Obj) => {
          let dataObj = {}
          dataObj['userId'] = Obj.studentID
          dataObj['FatherName'] = Obj.studentEnrollment.fatherName
          dataObj['StudentName'] = Obj.studentEnrollment.studentName

          if (this.sendType === 'Email') {
            dataObj['pointOfContact'] = Obj.studentEnrollment.fatherEmailID
          } else if (this.sendType === 'SMS') {
            dataObj['pointOfContact'] = Obj.studentEnrollment.fatherMobile
          }
          dataObj['Class'] = Obj.studentClass.name
          dataObj['Section'] = Obj.studentSection.name
          this.TableData.push(dataObj)
        })
        this.columns = [{ field: 'userId', label: 'Student Id', visible: false }]
        this.columns = [{ field: 'FatherName', label: 'Parent Name', visible: false }]
        this.columns = [{ field: 'StudentName', label: 'Student Name' }]
        this.columns.push({ field: 'pointOfContact', label: 'Point Of Contact' })
        this.columns.push({ field: 'Section', label: 'Section' }, { field: 'Class', label: 'Class' })
        this.searchFilterArray = this.TableData
      } else if (this.email.userType.toString() === 'staff') {
        this.columns = [
          { field: 'StaffName', label: 'Staff Name' },
          { field: 'userId', label: 'Staff ID', visible: false },
          { field: 'pointOfContact', label: 'Point Of Contact' },
          { field: 'StaffType', label: 'Staff Type' }
        ]
        this.data.forEach((Obj) => {
          let dataObj = {}
          dataObj['StaffName'] = Obj.user.firstName
          dataObj['userId'] = Obj.user.userStaff.userID
          if (this.sendType === 'Email') {
            dataObj['pointOfContact'] = Obj.user.email
          } else if (this.sendType === 'SMS') {
            dataObj['pointOfContact'] = Obj.user.userStaff.mobileNo
          }
          dataObj['StaffType'] = Obj.user.userStaff.isTeachingStaff ? 'Teaching' : 'Non Teaching'
          this.TableData.push(dataObj)
        })
        this.searchFilterArray = this.TableData
      } else if (this.email.userType.toString() === 'enquiry') {
        this.columns = [
          { field: 'userId', label: 'Id', visible: false },
          { field: 'StudentName', label: 'Student Name' },
          { field: 'fatherName', label: 'Parent Name' },
          { field: 'pointOfContact', label: 'Point Of Contact' },
          { field: 'Class', label: 'Class' },
          { field: 'AcademicYear', label: 'AcademicYear' }
        ]
        let Obj = this.data
        this.total = 1
        // this.data.forEach((Obj) => {
        let dataObj = {}
        dataObj['userId'] = Obj.id
        dataObj['StudentName'] = Obj.studentFirstName
        dataObj['fatherName'] = Obj.fatherName
        if (this.sendType === 'Email') {
          dataObj['pointOfContact'] = Obj.fatherEmailID
        } else if (this.sendType === 'SMS') {
          dataObj['pointOfContact'] = Obj.fatherMobile
        }
        dataObj['Class'] = Obj.studentClass.name
        dataObj['AcademicYear'] = Obj.franchiseeAcademicYear.academicYear

        this.TableData.push(dataObj)
        // })
        this.searchFilterArray = this.TableData
      }
    },
    getEmailTemplate: async function (templateUserTypeArr) {
      try {
        if (this.$route.query.type && this.$route.query.pageType) {
          let filterTemplateData = {
            templateType: this.$route.query.sendType.toUpperCase(),
            templatePageType: this.$route.query.pageType.toUpperCase(),
            templateUserType: templateUserTypeArr
          }
          const dataTemplate = await http.post(`${constants.API_URL}/api/communication/template/details`, filterTemplateData)

          if (dataTemplate.data.count > 0) {
            this.emailSendType = dataTemplate.data.rows
            this.email.templateTypeValue = dataTemplate.data.rows[0].id
            this.getEmailTemplateContent(dataTemplate.data.rows[0].id)
          }
        }
      } catch (e) {
        this.errMsg(e.message)
      }
    },
    getEmailTemplateContent: async function (templateId) {
      try {
        const dataTemplate = await http.get(`${constants.API_URL}/api/communication/template/${templateId}`)
        let templateDeatils = dataTemplate.data
        if (this.sendType === 'Email') {
          if (templateDeatils.templateContent || templateDeatils.templateEmailSubject) {
            this.email.emailEditorData = window.atob(templateDeatils.templateContent)
            this.email.emailSubject = templateDeatils.templateEmailSubject
            this.emailSubTxtBox = true
            this.emailContentTxtBox = true
          } else {
            this.emailSubTxtBox = false
            this.emailContentTxtBox = false
          }
        } else if (this.sendType === 'SMS') {
          if (templateDeatils.templateContent) {
            this.email.messageText = window.atob(templateDeatils.templateContent)
            this.readOnlyTxtBox = true
          } else {
            this.readOnlyTxtBox = false
          }
        }
      } catch (e) {
        this.errMsg(e.message)
      }
    },
    GetUserData: async function () {
      this.loadingComponent = this.$buefy.loading.open()
      let urlParamater = ''
      let UserType = []

      this.email.userType = this.$route.query.type
      this.sendType = this.$route.query.sendType

      urlParamater = `type=${this.$route.query.type}&franchiseeID=${this.$route.query.franchiseeID}&isActive=true`
      if (this.$route.query.id) {
        urlParamater += `&id=${this.$route.query.id}`
      }
      if (this.email.userType === 'staff') {
        UserType = ['ALL', 'STAFF']
        if (this.$route.query.isTeachingStaff) {
          urlParamater += `&isTeachingStaff=${this.$route.query.isTeachingStaff}`
        }
      } else if (this.email.userType === 'student') {
        UserType = ['ALL', 'PARENT']
        if (this.$route.query.academicYear) {
          urlParamater += `&academicYearID=${this.$route.query.academicYear}`
        }
        if (this.$route.query.isNewStudent) {
          urlParamater += `&isNewStudent=${this.$route.query.isNewStudent}`
        }
        if (this.$route.query.classID) {
          urlParamater += `&classID=${this.$route.query.classID}`
        }
        if (this.$route.query.sectionID) {
          urlParamater += `&sectionID=${this.$route.query.sectionID}`
        }
        if (this.$route.query.gender) {
          urlParamater += `&gender=${this.$route.query.gender}`
        }
        if (this.$route.query.isExistingStudent) {
          urlParamater += `&isExistingStudent=${this.$route.query.isExistingStudent}`
        }
      }

      this.activeTab = 0
      this.isListing = true

      try {
        const response = await http.get(`${constants.API_URL}/api/academic/search-data?${urlParamater}`)
        this.data = response.data
        this.total = this.data.length
        this.paginated = !!this.total
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While Listing of User Data: ${errorMessage}`)
        this.loadingComponent.close()
      }
      if (this.total === 0) {
        this.isDisabled = true
      } else {
        this.isDisabled = false
      }
      this.userListing()
      this.getEmailTemplate(UserType)
      this.loadingComponent.close()
    },
    SendToUser: async function () {
      try {
        if (this.email.checkedRows.length > 0) {
          this.isMessage = false
          this.activeTab = 1
        } else {
          this.errMsg(`Please Select Atleast One User `)
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While Sending Email: ${errorMessage}`)
      }
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
<style>
.left-margin {
  margin-left: 5px;
}
.chk {
  margin-left: 10px;
  margin-right: 10px;
}
.hidecolumn {
  display: none;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
